/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { columns, defaultFilter, filterForm, editForm } from './utils/list_data';
import { institutionsAPI } from 'src/api/modules/institutions';
import CustomButton from 'src/common/components/CustomButton';
import PageLayout from 'src/common/components/PageLayout';
import FullTable from 'src/common/components/FullTable';
import notice from 'src/common/components/Notice';
import DeleteUnit from './Modals/DeleteUnit';
import EditUnit from './Modals/EditUnit';
import { Add } from '@material-ui/icons';
import AddUnit from './Modals/AddUnit';

const AdministrativeUnit = () => {
	const [institutions, setInstitutions] = useState([]);
	const [institutionsName, setInstitutionsName] = useState([]);
	const [institutionsPre, setInstitutionsPre] = useState([]);
	const [filter, setFilter] = useState(defaultFilter);
	const [idUnit, setIdUnit] = useState([]);
	const [addUnitModal, setAddUnitModal] = useState(false);
	const [editModal, setEditModal] = useState(false);
	const [deleteModal, setDeleteModal] = useState(false);

	useEffect(() => {
		getAllInstitutions();
	}, []);

	useEffect(() => {
		if (filter.unidad || filter.prefijo || filter.estatus) {
			onConfirmFilter();
		} else {
			getInstitutions();
		}
	}, []);

	const getAllInstitutions = () => {
		let filterName = [];
		let filterPre = [];
		institutionsAPI
			.getAllinstitutions('UA')
			.then((response) => {
				if (response.instituciones && response.instituciones.length > 0) {
					response.instituciones.forEach((item) => {
						filterName.push({
							value: item.id,
							text: item.nombre,
						});

						if (item.prefijo !== '' && item.prefijo !== undefined)
							filterPre.push({
								value: item.id,
								text: item.prefijo,
							});
					});

					setInstitutionsName(filterName);
					setInstitutionsPre(filterPre);
				}
			})
			.catch((e) => notice('Ocurrio un error', 'error'));
	};

	const getInstitutions = () => {
		institutionsAPI
			.getAllinstitutions('UA')
			.then((response) => {
				if (response.instituciones && response.instituciones.length > 0) {
					setInstitutions(response.instituciones);
				}
			})
			.catch((e) => notice('Ocurrio un error', 'error'));
	};

	const onCloseModalAdd = () => {
		setIdUnit(editForm);
		setAddUnitModal(false);
	};

	const onCloseModalEdit = () => {
		setIdUnit(editForm);
		setEditModal(false);
	};

	const onSuccess = (msg, type_msg, type) => {
		notice(msg, type_msg);
		switch (type) {
			case 1:
				onCloseModalAdd();
				break;
			case 2:
				onCloseModalEdit();
				break;
			case 3:
				setDeleteModal(false);
				break;
			default:
				break;
		}
		getInstitutions();
	};

	const onConfirmFilter = () => {
		if (filter.unidad !== null)
			institutionsAPI
				.institutionId(filter.unidad.value)
				.then((response) => {
					setInstitutions(response.instituciones);
				})
				.catch(() => {
					notice('Ha ocurrido un error con la busqueda');
				});
		else if (filter.prefijo !== null)
			institutionsAPI
				.institutionPrefijo(filter.prefijo.text, 'UA')
				.then((response) => {
					setInstitutions(response.instituciones);
				})
				.catch(() => {
					notice('Ha ocurrido un error con la busqueda');
				});
		else if (filter.estatus !== null)
			institutionsAPI
				.institutionStatus(filter.estatus, 'UA')
				.then((response) => {
					setInstitutions(response.instituciones);
				})
				.catch(() => {
					notice('Ha ocurrido un error con la busqueda');
				});
	};

	const onNewUnit = () => {
		setAddUnitModal(true);
	};

	const onEditUnit = (dataRow) => {
		setIdUnit(dataRow);
		setEditModal(true);
	};

	const onDelete = (dataRow) => {
		setIdUnit(dataRow);
		setDeleteModal(true);
	};

	const onStatus = (dataRow) => {
		institutionsAPI
			.changeinstitucionStatus(
				dataRow.estatus === 'A' ? 'I' : 'A',
				dataRow.id,
				dataRow.prefijo
			)
			.then(() => {
				notice(
					`La unidad administrativa se ${
						dataRow.estatus === 'I' ? 'activo' : 'desactivo'
					} correctamente.`,
					'success'
				);
				getInstitutions();
			})
			.catch(() => {
				notice('Ha ocurrido un error en su solicitud');
			});
	};

	const onClear = () => {
		setFilter(defaultFilter);
		getInstitutions();
	};

	const handleChangeFilter = ({ target }) => {
		const { name, value } = target;
		if (name === 'unidad') {
			filter.prefijo = null;
			filter.estatus = null;
		}
		if (name === 'prefijo') {
			filter.unidad = null;
			filter.estatus = null;
		}
		if (name === 'estatus') {
			filter.unidad = null;
			filter.prefijo = null;
		}

		setFilter({ ...filter, [name]: value });
	};

	const onChangeData = ({ target }) => {
		setIdUnit({ ...idUnit, [target.name]: target.value });
	};

	return (
		<PageLayout>
			<CustomButton
				mainText="Nueva Unidad Administrativa"
				color="primary"
				className="m-3"
				icon={Add}
				style={{
					position: 'absolute',
					right: 35,
				}}
				onClick={() => {
					onNewUnit();
				}}
			/>
			<FullTable
				title="Unidades Admistrativas"
				items={institutions}
				columns={columns(onDelete, onEditUnit, onStatus)}
				filter={filter}
				filterForm={filterForm(
					onConfirmFilter,
					onClear,
					institutionsName,
					institutionsPre
				)}
				onFilterChange={handleChangeFilter}
				showPagination
				useBackendPagination={false}
			/>
			<AddUnit
				open={addUnitModal}
				parent={idUnit}
				onClose={onCloseModalAdd}
				onSuccess={onSuccess}
				onChangeData={onChangeData}
			/>
			<DeleteUnit
				open={deleteModal}
				onSuccess={onSuccess}
				onDelete={onDelete}
				unit={idUnit}
				onClose={() => {
					setDeleteModal(false);
				}}
			/>
			<EditUnit
				open={editModal}
				onClose={onCloseModalEdit}
				onSuccess={onSuccess}
				onDelete={onEditUnit}
				unit={idUnit}
				onChangeData={onChangeData}
			/>
		</PageLayout>
	);
};

export default AdministrativeUnit;
